import routes from '@routes';
import { CacheProps, fetchApi } from '../../../fetch';

interface EditAddressProps extends CacheProps {
  id: string
  address: string
  location: {
    lat: string,
    lng: string
  }
  plate: string
  unit: string
}

const editAddressApi = ({ id, address, location, plate, unit, ...rest }: EditAddressProps) => {
  return fetchApi({
    method: 'PUT',
    URL: {
      pathname: routes['api.contacts.edit'],
      query: {
        id: id,
      },
    },
    payload: {
      latitude: location?.lat,
      longitude: location?.lng,
      address: address,
      plate: plate,
      unit: unit,
    },
    withToken: true,
    ...rest,
  });
};

export default editAddressApi;
